import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { MODAL_TYPE } from 'Defaults/modals'
import { windowOpen } from 'Utils/routerUtils'
import { DOMAIN } from 'Config/config'
import SvgIcon from 'Components/SvgIcon'

import { MAX_COMPARE_LISTING_COUNT, COMPARE_GA_CATEGORY } from 'Components/CompareGrid'

import {
  _ShareMenuRow,
  _ShareBtnContainer,
  _CompareBtn,
  _PrintBtn,
  _EmailBtn,
} from './styles'

class UserFavourites extends Component {
  constructor(props) {
    super(props)

    this.onPrintClick = this.onPrintClick.bind(this)
    this.onEmailClick = this.onEmailClick.bind(this)
    this.onCompareClick = this.onCompareClick.bind(this)
  }

  onPrintClick() {
    const { selectedListings } = this.props
    if(selectedListings.length && typeof window !== 'undefined') {
      const mlsList = []
      selectedListings.map(listing => mlsList.push(listing.mls_number))
      const mlsListString = mlsList.join(',')

      const win = windowOpen(`/print/listings/${mlsListString}`, '_blank')
      win.focus()
    }
  }

  onEmailClick() {
    const { selectedListings } = this.props
    if(selectedListings.length) {
      const mlsNumbersArr = []
      const urlList = []
      selectedListings.forEach(listing => {
        mlsNumbersArr.push(listing.mls_number)
        urlList.push(`${DOMAIN}/${listing.url}`)
      })

      this.props.openModal({
        modalType: MODAL_TYPE.SHARE_PAGE,
        modalSource: 'favourites',
        modalData: {
          mlsNumbersArr,
          emailListingsView: true,
        },
      })
    }
  }

  onCompareClick() {
    const { selectedListings, googleAnalyticsEvent } = this.props
    if(selectedListings.length > 1 && selectedListings.length <= MAX_COMPARE_LISTING_COUNT) {
      const mlsList = []
      selectedListings.map(listing => mlsList.push(listing.mls_number))
      const mlsListString = mlsList.join(',')

      googleAnalyticsEvent({
        category: COMPARE_GA_CATEGORY,
        action: ['Favourite Page Compare Listings', `${selectedListings.length} Listings Compared`],
      })

      if(typeof window !== 'undefined') {
        window.location.href = `/compare-listings?mls_number=${mlsListString}`
      }
    } else {
      this.props.openModal({
        modalType: MODAL_TYPE.INFO,
        modalSource: 'favourites',
        modalData: {
          failureCrossmark: true,
          modalTitle: 'Sorry...',
          modalBody: `You have to select 2-${MAX_COMPARE_LISTING_COUNT} listings to compare.`,
        },
      })

      googleAnalyticsEvent({
        category: COMPARE_GA_CATEGORY,
        action: ['Favourite Page Compare Listings Error', `${selectedListings.length} Listings`],
      })
    }
  }

  render() {
    const { selectedListings, isMobileApp, isUserAgentAdminSupport } = this.props
    const shareActive = selectedListings.length
    return (
      <_ShareMenuRow top="xs">
        <_ShareBtnContainer
          active={shareActive}
          // hidden={!shareActive && !isSelectionMode}
          align="center"
          isMobileApp={isMobileApp}
        >
          <_CompareBtn
            primary
            onClick={this.onCompareClick}
            disabled={!shareActive}
          >


            <SvgIcon name="#icon-compare" width="16" height="16" />
            <span>Compare
              {
                selectedListings && selectedListings.length
                  ? ` ${selectedListings.length}/${MAX_COMPARE_LISTING_COUNT}` : ` 0/${MAX_COMPARE_LISTING_COUNT}`
              }
            </span>
          </_CompareBtn>
          <_EmailBtn secondary onClick={this.onEmailClick} disabled={!shareActive}>
            <SvgIcon name="#icon-share" width="12" height="12" />
            <span>Email</span>
          </_EmailBtn>
          {isUserAgentAdminSupport && (
            <_PrintBtn secondary onClick={this.onPrintClick} disabled={!shareActive}>
              <SvgIcon name="#icon-printer" width="16" height="16" />
              <span>Print</span>
            </_PrintBtn>
          )}

        </_ShareBtnContainer>
      </_ShareMenuRow>
    )
  }
}

UserFavourites.propTypes = {
  selectedListings: PropTypes.arrayOf(PropTypes.shape({})),
  openModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  isMobileApp: PropTypes.bool,
  isUserAgentAdminSupport: PropTypes.bool,
}

export default UserFavourites
